import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class TotalBalancesService {
    constructor(private http:Http) {
    }

    private totalBalances: Array<any>;

    getTotalBalances(): Observable<Array<any>> {
        if (isEmpty(this.totalBalances)) {
            return this.http.get('/api/client/dictionary/total_balances')
                .map(response => response.json())
                .map(response => {
                    this.totalBalances = response.totalBalances;
                    return this.totalBalances;
                });
        } else {
            return Observable.of(this.totalBalances);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/total.balances.service.ts